// extracted by mini-css-extract-plugin
export default {"latest-news":"LatestNews_latest-news__AdFAv","title":"LatestNews_title__LQHSP"};